// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"23":"on-board","104":"password","154":"organisation-users","528":"reports","701":"classes","844":"organisations","884":"admin","936":"registration","966":"login","983":"products"}[chunkId] || chunkId) + ".css";
};